import { ExportLog } from '../models/ExportLog';
import { host, getRequest } from './apiService';

export async function getLogs(fromDate: string, toDate: string) {
	return getRequest<ExportLog[]>(`${host}/api/exportlog?startDate=${fromDate}&endDate=${toDate}`);
}